import request from '@/utils/request'

// 消息列表
export function noticeList(query) {
  return request({
    url: '/v1.0/iwrs/notice/all',
    method: 'get',
    params: query
  })
}

// 置顶
export function top(data) {
  return request({
    url: '/v1.0/iwrs/notice/set/top',
    method: 'post',
    data
  })
}

// 取消置顶
export function cancelTop(data) {
  return request({
    url: '/v1.0/iwrs/notice/cancel/top',
    method: 'post',
    data
  })
}

// 显示消息
export function read(query) {
  return request({
    url: '/v1.0/iwrs/notice/no_read_count',
    method: 'get',
    params: query
  })
}

// 将指定消息设为已读
export function readInfo(data) {
  return request({
    url: '/v1.0/iwrs/notice/read',
    method: 'post',
    data
  })
}
